import { Injectable } from '@angular/core';
import { IAro, IAroTable } from '../common/inject';
import * as settings from '../common/settings';
import * as enums from '../common/enums';

const MINIMUM_HEIGHT_FOR_MULTIPLE_ARO: number = 900;

@Injectable({
  providedIn: 'root'
})
export class AroService {

  private trackAro: IAro = null;
  private plotAro: IAro = null;
  private sensorAro: IAro = null;
  private aroTable: IAroTable = null;
  private angTrackAro: IAro = null;

  public setTrackAro(trackAro: IAro) {
    this.trackAro = trackAro;
  }

  public setPlotAro(plotAro: IAro) {
    this.plotAro = plotAro;
  }

  public setSensorAro(sensorAro: IAro) {
    this.sensorAro = sensorAro;
  }

  public setAroTable(aroTable: IAroTable) {
    this.aroTable = aroTable;
  }

  public setAngTrackAro(angTrackAro: IAro) {
    this.angTrackAro = angTrackAro;
  }

  public showAro(objectId): boolean {
    let shown = this.showTrackAro(objectId);
    if (!shown){
      shown = this.showPlotAro(objectId);
      if (!shown){
        shown = this.showSensorAro(objectId);
      }
    }
    return shown;
  }

  public showTrackAro(trackId): boolean {
    let shown = this.trackAro.showAro(trackId);
    if (shown && !this.multipleAroValid()){
      this.hidePlotAro();
      this.hideSensorAro();
      this.hideAroTable();
    }
    return shown;
  }

  public showPlotAro(plotId): boolean {
    let shown = this.plotAro.showAro(plotId);
    if (shown && !this.multipleAroValid()) {
      this.hideTrackAro();
      this.hideSensorAro();
      this.hideAngTrackAro();
      this.hideAroTable();
    }
    return shown;
  }

  public showSensorAro(sensorId): boolean {
    let shown = this.sensorAro.showAro(sensorId);
    if (shown && !this.multipleAroValid()) {
      this.hideTrackAro();
      this.hidePlotAro();
      this.hideAroTable();
      this.hideAroTable();
      this.hideAngTrackAro();
    }
    return shown;
  }

  public showAngTrackAro(angTrackId): boolean {
    let shown = this.angTrackAro.showAro(angTrackId);
    if (shown && !this.multipleAroValid()) {
      this.hideTrackAro();
      this.hidePlotAro();
      this.hideAroTable();
      this.hideTrackAro();
      this.hideSensorAro();
    }
    return shown;
  }

  public showAroTable(trackIds: Set<number>): void {
    this.aroTable.show(trackIds);
    this.hideTrackAro();
    if (this.isPlotAroShown() && !this.multipleAroValid())
      this.hidePlotAro();
  }

  public hideTrackAro() {
    if (this.trackAro.isShown())
      this.trackAro.hideAro();
  }

  public hidePlotAro() {
    if (this.plotAro.isShown())
      this.plotAro.hideAro();
  }

  public hideSensorAro() {
    if (this.sensorAro.isShown())
      this.sensorAro.hideAro();
  }

  public hideAngTrackAro() {
    if (this.angTrackAro.isShown())
      this.angTrackAro.hideAro();
  }

  public isTrackAroShown() {
    return this.trackAro != null && this.trackAro.isShown();
  }

  public isPlotAroShown() {
    return this.plotAro != null && this.plotAro.isShown();
  }

  public isSensorAroShown() {
    return this.sensorAro != null && this.sensorAro.isShown();
  }

  public isAngTrackAroShown() {
    return this.angTrackAro != null && this.angTrackAro.isShown();
  }

  public getShownTrackId() {
    return this.trackAro.getShownId();
  }

  public getShownAngTrackId() {
    return this.angTrackAro.getShownId();
  }

  public getShownPlotId() {
    return this.plotAro.getShownId();
  }

  public getShownSensorId() {
    return this.plotAro.getShownId();
  }

  public getAngTrackId() {
    return this.plotAro.getShownId();
  }

  public getShownAroTableIds(): Set<number> {
    return this.aroTable.getObjectIds();
  }

  public locationClick() {
    if (settings.userSettings.coordinatesType == enums.CoordinateType.WGS84_DMM)
      settings.userSettings.setCoordinatesType(enums.CoordinateType.WGS84_DMS);
    else if (settings.userSettings.coordinatesType == enums.CoordinateType.WGS84_DMS)
      settings.userSettings.setCoordinatesType(enums.CoordinateType.UTM);
    else if (settings.userSettings.coordinatesType == enums.CoordinateType.UTM)
      settings.userSettings.setCoordinatesType(enums.CoordinateType.WGS84_DMM);
    else
      return;
    this.updateLocation();
  }

  public updateLocation() {
    if (this.trackAro)
      this.trackAro.updateLocation();
    if (this.plotAro)
      this.plotAro.updateLocation();
    if (this.sensorAro)
      this.sensorAro.updateLocation();
  }

  private multipleAroValid(): boolean {
    return window.innerHeight > MINIMUM_HEIGHT_FOR_MULTIPLE_ARO;
  }

  public hideAroTable() {
    if (this.aroTable.isShown())
      this.aroTable.hide();
  }

  public isAroTableShown() {
    return this.aroTable != null && this.aroTable.isShown();
  }
}
